import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import { APP_URL } from "./data/site";
import { GAMES } from "./data/games";

import Home from "./Pages/Home";
import Chart from "./Pages/Chart";
import GameResult from "./Pages/GameResult";
import Faq from "./Pages/Faq";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Privacy from "./Pages/Privacy";
import Terms from "./Pages/Terms";
import Disclaimer from "./Pages/Disclaimer";
import NotFound from "./Pages/NotFound";

const APP_BAR_DELAY_MS = 5000;
const APP_BAR_DISMISSED_KEY = "appBarDismissed";

/**
 * Slim bar pinned to the bottom of the viewport. It replaced a full-screen
 * popup: Google demotes pages whose content is covered by an interstitial on
 * mobile, and the full offer is already shown in-page by <AppPromo />.
 */
function AppBar({ onClose }) {
  return (
    <aside className="app-bar" aria-label="Bagad Satta App">
      <span className="app-bar-text">
        <strong>Bagad Satta App</strong> — PRO &amp; MAX accounts
      </span>
      <a
        href={APP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="app-bar-btn"
      >
        Download
      </a>
      <button
        type="button"
        className="app-bar-close"
        onClick={onClose}
        aria-label="Dismiss app banner"
      >
        ×
      </button>
    </aside>
  );
}

function wasDismissed() {
  try {
    return window.sessionStorage.getItem(APP_BAR_DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
}

function App() {
  const [showAppBar, setShowAppBar] = useState(false);

  useEffect(() => {
    if (wasDismissed()) return undefined;
    const timerId = window.setTimeout(() => {
      setShowAppBar(true);
    }, APP_BAR_DELAY_MS);

    return () => window.clearTimeout(timerId);
  }, []);

  const dismissAppBar = () => {
    setShowAppBar(false);
    try {
      window.sessionStorage.setItem(APP_BAR_DISMISSED_KEY, "1");
    } catch {
      /* private mode — the bar just comes back next page load */
    }
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/satta-chart" element={<Chart />} />
          {GAMES.map((game) => (
            <Route
              key={game.key}
              path={`/${game.slug}`}
              element={<GameResult gameKey={game.key} />}
            />
          ))}
          <Route path="/faq" element={<Faq />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />

          {/* Legacy / alternate spellings kept alive so no earned link 404s. */}
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/chart" element={<Navigate to="/satta-chart" replace />} />
          <Route path="/about" element={<Navigate to="/about-us" replace />} />
          <Route path="/contact" element={<Navigate to="/contact-us" replace />} />
          <Route path="/terms" element={<Navigate to="/terms-and-conditions" replace />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>

      {showAppBar && (
        <>
          <div className="app-bar-spacer" aria-hidden="true" />
          <AppBar onClose={dismissAppBar} />
        </>
      )}
    </BrowserRouter>
  );
}

export default App;
